// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__JhGc5","Fullwidth":"Layout_Fullwidth__24AhX"};